import React, { useMemo } from "react";
import { Table, Input, Button, DatePicker } from "antd";
import dayjs from "dayjs";

export default function InvoiceTable({
  formData,
  updateInvoice,
  removeInvoice,
  addInvoice,
  totalQty,
  totalValue,
  onBlurCheckDuplicateInvoice,
}) {
  const columns = [
    {
      title: "Invoice No",
      dataIndex: "invoiceNo",
      render: (text, record, index) => (
        <Input
          value={text}
          placeholder="No"
          onChange={(e) => updateInvoice(index, "invoiceNo", e.target.value)}
          onBlur={() => onBlurCheckDuplicateInvoice(index)}
        />
      ),
    },
    {
      title: "Invoice Date",
      dataIndex: "invoiceDate",
      render: (text, record, index) => (
        <DatePicker
          style={{ width: "100%" }}
          format="DD-MM-YYYY"
          value={text ? dayjs(text) : null}
          onChange={(date) =>
            updateInvoice(
              index,
              "invoiceDate",
              date ? date.format("YYYY-MM-DD") : ""
            )
          }
           disabledDate={(current) => {
        // Disable future dates
        return current && current > dayjs().endOf("day");
      }}
        />
      ),
    },

    {
      title: "Qty",
      dataIndex: "invoiceQty",
      render: (text, record, index) => (
        <Input
          value={text}
          placeholder="Qty"
          type="text"
          onChange={(e) =>
            updateInvoice(index, "invoiceQty", e.target.value, totalQty)
          }
        />
      ),
    },
    {
      title: "Value",
      dataIndex: "invoiceValue",
      render: (text, record, index) => (
        <Input
          value={text}
          placeholder="Value"
          type="text"
          onChange={(e) =>
            updateInvoice(index, "invoiceValue", e.target.value, totalValue)
          }
        />
      ),
    },
    {
      title: "X",
      width: 60,
      render: (_, record, index) =>
        index > 0 && (
          <Button danger onClick={() => removeInvoice(index)}>
            X
          </Button>
        ),
    },
  ];

  return (
    <>
      <Button
        type="primary"
        onClick={() => addInvoice(totalValue)}
        style={{
          display: "flex",
          justifyContent: "flex-end",
          marginBottom: 10,
        }}
      >
        + Add
      </Button>
      <Table
        columns={columns}
        dataSource={formData.invoiceDetails}
        pagination={false}
        rowKey={(record, index) => index}
        footer={() => (
          <div
            style={{
              display: "flex",
              fontWeight: "bold",
              justifyContent: "space-between",
            }}
          >
            <span>TOTAL</span>
            <span>{totalQty}</span>
            <span>{totalValue}</span>
            <span></span>
          </div>
        )}
      />
    </>
  );
}
